import React from 'react';
import { Checkbox } from 'yankees-react-utils';

const ObjectiveCategories = ({ categories, updateCategories }) => {
    const onCheckboxClick = (category) => {
        const copy = [...categories];

        const categoryCopy = copy.find((c) => c.categoryId === category.categoryId);
        categoryCopy.isSelected = !category.isSelected;

        if (!category.isAll) {
            const allCategory = copy.find((c) => c.isAll);
            allCategory.isSelected = false;
        } else if (category.isSelected) {
            copy.filter((c) => !c.isAll).forEach((c) => { c.isSelected = true; });
        }

        updateCategories(copy);
    };

    return (
        <div className="d-flex align-items-center">
            {categories.map((c) => <Checkbox id={`checkbox-${c.categoryId}`} checked={c.isSelected} label={c.name} size={12} key={c.categoryId} onChange={() => onCheckboxClick(c)} />)}
        </div>
    );
};

export default ObjectiveCategories;
